import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Config from '../../../config';
import allColors from '../../../assets/style/allColors';
import Images from '../../../assets/images';

const Unauthorized = ({ history }) => {
  const status = useSelector(({ errors }) => errors.status);
  const pushToLogout = () => {
    history.push('/logout');
  };

  const pushToHome = () => {
    history.push('/');
  };

  const renderFourZeroNine = () => {
    return (
      <div>
        <ErrorTitle>{Config.TextStrings.errorOccurred}</ErrorTitle>
        <ErrorText>{Config.TextStrings.anotherUserLoggedIn}</ErrorText>
        <ErrorText>{Config.TextStrings.logInAgain}</ErrorText>
        <Button onClick={pushToLogout}>{Config.TextStrings.clickLogOut}</Button>
      </div>
    );
  };

  const renderFourZeroOne = () => {
    return (
      <div>
        <ErrorTitle>{Config.TextStrings.errorOccurred}</ErrorTitle>
        <ErrorText>{Config.TextStrings.tokenExpired}</ErrorText>
        <ErrorText>{Config.TextStrings.logInAgain}</ErrorText>
        <Button onClick={pushToLogout}>
          {Config.TextStrings.clickContinue}
        </Button>
      </div>
    );
  };

  const renderDefaultMessage = () => {
    return (
      <div>
        <ErrorTitle>{Config.TextStrings.errorScreen}</ErrorTitle>
        <ErrorText>{Config.TextStrings.logInAgain}</ErrorText>
        <Button onClick={pushToHome}>{Config.TextStrings.backHome}</Button>
      </div>
    );
  };

  const renderCorrectErrorMessage = () => {
    if (status === 409) {
      return renderFourZeroNine();
    } else if (status === 401) {
      return renderFourZeroOne();
    } else {
      return renderDefaultMessage();
    }
  };

  return (
    <ErrorWrapper>
      {renderCorrectErrorMessage()}
      <GearSVG src={Images.Gear} alt="loading" />
    </ErrorWrapper>
  );
};

const ErrorWrapper = styled.div`
  background-color: ${allColors.dark};
  text-align: center;
  color: #ffffff;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ErrorTitle = styled.h1``;

const ErrorText = styled.p`
  padding-top: 10px;
`;
const GearSVG = styled.img`
  margin-top: 46px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 100px;
`;

const Button = styled.button`
  padding: 5px;
  background-color: #40aec2;
  margin-top: 30px;
  text-decoration: none;
  color: #ffffff;
  border-radius: 4px;
  height: 50px;
  width: 280px;
  border: #40aec2 1px solid;
  font-size: 16px;
  &:hover {
    text-decoration: none;
    color: #ffffff;
    cursor: pointer;
  }
  &:active {
    text-decoration: none;
    color: #ffffff;
  }
  &:focus {
    text-decoration: none;
    color: #ffffff;
  }
`;

export default Unauthorized;
